import Vue from 'vue'
import VueRouter from 'vue-router'
import SecurPos from '../views/securpos.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: SecurPos
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('../views/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
